import axios, { AxiosResponse } from 'axios';
import { Tag, UsuarioEmpresa, Empresa, EmpresaProducto } from './suite.interfaces';
import { CommonService } from './common.services';

export class EmpresaService extends CommonService {

  async findEmpresaBy(evento: number, id: number): Promise<Empresa> {
    try {
      const response: AxiosResponse<Empresa> = await axios.get(super.getServerUrl() + '/mobile/findEmpresaBy?evento=' + evento + '&idEmpresa=' + id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findEmpresasBy(evento: number, moduloEmpresa: number): Promise<Empresa[]> {
    try {
      const response: AxiosResponse<Empresa[]> = await axios.get(super.getServerUrl() + '/mobile/findEmpresasBy?evento=' + evento + '&moduloEmpresa=' + moduloEmpresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findEmpresasProductosBy(evento: number): Promise<EmpresaProducto[]> {
    try {
      const response: AxiosResponse<EmpresaProducto[]> = await axios.get(super.getServerUrl() + '/mobile/findEmpresasProductosBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async saveOrUpdateAll(evento: number, empresas: Empresa[]): Promise<Empresa[]> {
    try {
      const empresasList = { "empresas": empresas };
      const response: AxiosResponse<Empresa[]> = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdate?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async saveOrUpdate(evento: number, empresa: Empresa): Promise<Empresa> {
    try {
      const empresasList = { "empresas": [empresa] };
      const response: AxiosResponse<Empresa[]> = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdate?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data[0] as Empresa;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findUsuarioEmpresaBy(mailResponsable: string, pwd: string): Promise<UsuarioEmpresa> {
    try {
      const dataForm = { "mail": mailResponsable, "pwd": pwd };
      const response: AxiosResponse<UsuarioEmpresa> = await axios.post(super.getServerUrl() + '/mobile/findUsuarioEmpresaBy?', dataForm, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async updateLogo(evento: number, empresa: Empresa): Promise<boolean> {
    try {
      const dataForm = { "empresa": empresa };
      const response: AxiosResponse<string> = await axios.post(super.getServerUrl() + '/mobile/updateLogo?evento=' + evento, dataForm, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "Ok");
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findProductosBy(evento: number, idEmpresa: number): Promise<EmpresaProducto[]> {
    try {
      const response: AxiosResponse<EmpresaProducto[]> = await axios.get(super.getServerUrl() + '/mobile/findProductosBy?evento=' + evento + '&idEmpresa=' + idEmpresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findProductoByPk(evento: number, idProducto: number): Promise<EmpresaProducto> {
    try {
      const response: AxiosResponse<EmpresaProducto> = await axios.get(super.getServerUrl() + '/mobile/findProductoByPk?idEvento=' + evento + '&idProducto=' + idProducto, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async removeProductoBy(evento: number, idProducto: number): Promise<string> {
    try {
      const response: AxiosResponse<string> = await axios.get(super.getServerUrl() + '/mobile/removeProductoBy?evento=' + evento + '&idProducto=' + idProducto, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findTagsBy(evento: number, tipo: number): Promise<Tag[]> {
    try {
      const response: AxiosResponse<Tag[]> = await axios.get(super.getServerUrl() + '/mobile/findTagsBy?evento=' + evento + "&tipo=" + tipo, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async saveOrUpdateAllProductos(evento: number, productos: EmpresaProducto[]): Promise<EmpresaProducto[]> {
    try {
      const empresasList = { "empresaProductos": productos };
      const response: AxiosResponse<EmpresaProducto[]> = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdateProductos?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async saveOrUpdateProducto(evento: number, producto: EmpresaProducto): Promise<EmpresaProducto> {
    try {
      const empresasList = { "empresaProductos": [producto] };
      const response: AxiosResponse<EmpresaProducto[]> = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdateProductos?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data[0] as EmpresaProducto;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async actualizarAccesoUsuarioEmpresa(evento: number, idUsuarioEmpresa: number, claveActual: string, claveNueva: string): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.post(this.getServerUrl() + '/mobile/actualizarAccesoUsuarioEmpresa?evento=' + evento + '&idUsuarioEmpresa=' + idUsuarioEmpresa + "&actual=" + claveActual + "&nueva=" + claveNueva, {}, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }
}